import React, { Fragment, useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { RestHelperNoAuth } from "../helper/restHelperNoAuth";
import mixpanel from "mixpanel-browser";

import { Hero, HomeContent } from "../components";

const Preview = () => {

    const [message, setResponse] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [isInitialLoading, setIsInitialLoading] = useState(true)
    const [showAppt, setShowAppt] = useState(false)
    const [showClaimForm, setShowClaimForm] = useState(false)
    const [showCounterForm, setShowCounterForm] = useState(false)
    const [updateResponse, setUpdateResponse] = useState([])
    const [isOpen, setIsOpen] = useState(false)
    const [isPending, setIsPending] = useState(false)
    const [isScheduled, setIsScheduled] = useState(false)
    const [counterBid, setCounterBid] = useState('')
    const [initialBid, setInitialBid] = useState('')
    const api = RestHelperNoAuth()

    const setInitialResponse = (res) => {
      setIsOpen(res[0]['status'])
      setIsPending(res[0]['statusPending'])
      setIsScheduled(res[0]['statusScheduled'])
      setInitialBid(res[0]['apptOffer'])
      setIsInitialLoading(false)
      setResponse(res)
    }

  useEffect(() => {
    mixpanel.track('Notary Preview', { 'action': 'preview' })
  }, [,])

    const getRequest = (params) => {
     api
      .get('/get-basic-request?' + params)
      .then(res => setInitialResponse(res))
      .catch(err => console.log(err))
    setIsLoading(false)
    setShowAppt(true)
    }
    const { id } = useParams();
    useEffect (() => {
        setIsLoading(true)
        getRequest(id);
      }, []);

    const updateRequest = (action, bid) => {
      const updateParams = {id, 'action': action, 'bid': bid}
      const options = {}
      mixpanel.track('Notary Preview', {'action': action})
      api
        .postCreate('/update-open-request', options,updateParams)
        .then(res => setUpdateResponse(res))
        .catch(err => console.log(err))
      setShowClaimForm(true)
    }

    const onChangeEvent = (evt) => {
      var value = evt.target.value;
      value = value.replace('$', '')
      setCounterBid(value)
    }

    const dateFormat = (inputDate) => {
      const dateArray = inputDate.split("-")
      const date = dateArray[1] + '/' + dateArray[2] + '/' + dateArray[0]
      return date
    }

    function convertTimeToAMPM(time24) {
      if (time24 === 'TBD') {
        return 'TBD'
      }
      var hours = parseInt(time24.substr(0, 2));
      var minutes = parseInt(time24.substr(3));
      var ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      var minutesStr = minutes < 10 ? '0' + minutes : minutes;
      var time12 = hours + ':' + minutesStr + ' ' + ampm;
      return time12;
    }

    const setFee = () => {
      const fee = '$' + counterBid
      return fee
  }

  const scanBackCheck = (checkFlag) => {
    var scanBackValue = ''
    if (checkFlag === 'true') {
      scanBackValue = 'SCAN BACKS ARE REQUIRED'
    }
    else{
      scanBackValue = 'NONE'
    }
    return scanBackValue

  }

  function setTransactionType(setValue) {
    if (setValue === '0') {
      return 'Not Defined'
    }
    else if (setValue === '1') {
      return 'Purchase'
    }
    else if (setValue === '2') {
      return 'Refinance'
    }
    else if (setValue === '3') {
      return 'Sellers Deed Set'
    }
    else if (setValue === '4') {
      return 'Other'
    }
    else {
      return 'Not Defined'
    }
  }

  function setFinanceType(setValue) {
    if (setValue === '10') {
      return 'Not Defined'
    }
    else if (setValue === '11') {
      return 'FHA'
    }
    else if (setValue === '12') {
      return 'Conventional'
    }
    else if (setValue === '13') {
      return 'Reverse'
    }
    else if (setValue === '14') {
      return 'HELOC'
    }
    else if (setValue === '15') {
      return 'Commercial'
    }
    else if (setValue === '16') {
      return 'VA'
    }
    else {
      return 'Not Defined'
    }
  }

    const onSubmitHandler = () => {
      setIsLoading(true)
      setShowClaimForm(false)
      setShowAppt(false)
      setShowCounterForm(false)
      updateRequest('counter', counterBid)
    }

    useEffect (() => {
      setIsLoading(false)
    }, [updateResponse, setUpdateResponse])

    const onClickHandler = (action) => {
      if (action == 'claim') {
        setIsLoading(true)
        setShowClaimForm(false)
        setShowAppt(false)
        updateRequest(action, initialBid)
      }
      if (action == 'counter') {
        setShowClaimForm(false)
        setShowAppt(false)
        setShowCounterForm(true)
      }
      if (action == 'decline') {
        setIsLoading(true)
        setShowClaimForm(false)
        setShowAppt(false)
        updateRequest(action, '')
      }
    }

    return (
        <Fragment>
          {isOpen
          ? <div>{showAppt && (
            <div className="max-w-2xl mx-auto px-4 mt-6 mb-6">
              <div className="bg-white rounded-xl shadow-md border border-neutral-200 overflow-hidden">
                {message.map((items =>
                  <div key={items.apptDate}>
                    <div className="px-6 py-4 bg-gradient-to-r from-blue-600 to-blue-700">
                      <h2 className="text-lg font-semibold text-white">Hi {items.apptNotary}, are you available for this signing?</h2>
                    </div>
                    <div className="p-6">
                      <div className="space-y-1">
                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-3 border-b border-neutral-100">
                          <div className="font-medium text-neutral-600">When</div>
                          <div className="sm:col-span-2 text-neutral-800">{dateFormat(items.apptDate)} at {convertTimeToAMPM(items.apptTime)} {items.apptTimeZone}</div>
                        </div>
                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-3 border-b border-neutral-100">
                          <div className="font-medium text-neutral-600">Where</div>
                          <div className="sm:col-span-2 text-neutral-800">{items.apptCity}, {items.apptState} {items.apptZip}</div>
                        </div>
                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-3 border-b border-neutral-100">
                          <div className="font-medium text-neutral-600">Notary Fee</div>
                          <div className="sm:col-span-2 text-neutral-800 font-semibold text-green-600">${items.apptOffer}</div>
                        </div>
                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-3 border-b border-neutral-100">
                          <div className="font-medium text-neutral-600">Lender</div>
                          <div className="sm:col-span-2 text-neutral-800">{items.apptLender}</div>
                        </div>
                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-3 border-b border-neutral-100">
                          <div className="font-medium text-neutral-600">Scan Backs</div>
                          <div className="sm:col-span-2">
                            <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${items.scanBack === 'true' ? 'bg-amber-100 text-amber-800' : 'bg-neutral-100 text-neutral-800'}`}>
                              {scanBackCheck(items.scanBack)}
                            </span>
                          </div>
                        </div>
                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-3 border-b border-neutral-100">
                          <div className="font-medium text-neutral-600">Transaction Type</div>
                          <div className="sm:col-span-2 text-neutral-800">{setTransactionType(items.transactionType)}</div>
                        </div>
                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-3 border-b border-neutral-100">
                          <div className="font-medium text-neutral-600">Finance Type</div>
                          <div className="sm:col-span-2 text-neutral-800">{setFinanceType(items.financeType)}</div>
                        </div>
                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-3 border-b border-neutral-100">
                          <div className="font-medium text-neutral-600">Extra Notes</div>
                          <div className="sm:col-span-2 text-neutral-800">{items.apptMessages}</div>
                        </div>
                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-3">
                          <div className="font-medium text-neutral-600">Status</div>
                          <div className="sm:col-span-2">
                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                              {items.apptNotaryApproval}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
                <div className="px-6 py-5 bg-neutral-50 border-t border-neutral-200">
                  <p className="text-sm text-neutral-600 mb-4">Please select an option below to either claim the offer, propose a counter offer, or decline this offer:</p>
                  <div className="flex flex-col sm:flex-row gap-3">
                    <button type='button' className="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-6 rounded-lg transition-colors" onClick={()=>onClickHandler('claim')}>Claim</button>
                    <button type='button' className="flex-1 bg-neutral-200 hover:bg-neutral-300 text-neutral-800 font-medium py-3 px-6 rounded-lg transition-colors" onClick={()=>onClickHandler('counter')}>Counter</button>
                    <button type='button' className="flex-1 bg-red-500 hover:bg-red-600 text-white font-medium py-3 px-6 rounded-lg transition-colors" onClick={()=>onClickHandler('decline')}>Decline</button>
                  </div>
                </div>
              </div>
            </div>)}</div>
          : <div>
            {isPending
              ? (<div className="max-w-2xl mx-auto px-4 mt-6 mb-6">
                <div className="bg-white rounded-xl shadow-md border border-neutral-200 overflow-hidden">
                  {message.map((items =>
                    <div key={items.apptDate}>
                      <div className="px-6 py-4 bg-gradient-to-r from-amber-500 to-amber-600">
                        <h2 className="text-lg font-semibold text-white">Hi {items.apptNotary}, this signing is currently in a pending status</h2>
                      </div>
                      <div className="p-6">
                        <div className="space-y-1">
                          <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-3 border-b border-neutral-100">
                            <div className="font-medium text-neutral-600">When</div>
                            <div className="sm:col-span-2 text-neutral-800">{items.apptDate} at {convertTimeToAMPM(items.apptTime)} {items.apptTimeZone}</div>
                          </div>
                          <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-3 border-b border-neutral-100">
                            <div className="font-medium text-neutral-600">Where</div>
                            <div className="sm:col-span-2 text-neutral-800">{items.apptCity}, {items.apptState} {items.apptZip}</div>
                          </div>
                          <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-3 border-b border-neutral-100">
                            <div className="font-medium text-neutral-600">Lender</div>
                            <div className="sm:col-span-2 text-neutral-800">{items.apptLender}</div>
                          </div>
                          <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-3 border-b border-neutral-100">
                            <div className="font-medium text-neutral-600">Scan Backs</div>
                            <div className="sm:col-span-2">
                              <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${items.scanBack === 'true' ? 'bg-amber-100 text-amber-800' : 'bg-neutral-100 text-neutral-800'}`}>
                                {scanBackCheck(items.scanBack)}
                              </span>
                            </div>
                          </div>
                          <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-3 border-b border-neutral-100">
                            <div className="font-medium text-neutral-600">Transaction Type</div>
                            <div className="sm:col-span-2 text-neutral-800">{setTransactionType(items.transactionType)}</div>
                          </div>
                          <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-3 border-b border-neutral-100">
                            <div className="font-medium text-neutral-600">Finance Type</div>
                            <div className="sm:col-span-2 text-neutral-800">{setFinanceType(items.financeType)}</div>
                          </div>
                          <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-3 border-b border-neutral-100">
                            <div className="font-medium text-neutral-600">Extra Notes</div>
                            <div className="sm:col-span-2 text-neutral-800">{items.apptMessages}</div>
                          </div>
                          <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-3">
                            <div className="font-medium text-neutral-600">Status</div>
                            <div className="sm:col-span-2">
                              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-amber-100 text-amber-800">
                                {items.apptNotaryApproval}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>))}
                </div>
              </div>)
              : <div>{isScheduled
                  ? (<div className="max-w-2xl mx-auto px-4 mt-6 mb-6">
                      <div className="bg-white rounded-xl shadow-md border border-neutral-200 overflow-hidden">
                        {message.map((items =>
                          <div key={items.apptDate}>
                            <div className="px-6 py-4 bg-gradient-to-r from-green-600 to-green-700">
                              <h2 className="text-lg font-semibold text-white">Hi {items.apptNotary}, your offer has been approved and the signing is assigned to you!</h2>
                            </div>
                            <div className="p-6">
                              <div className="space-y-1">
                                <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-3 border-b border-neutral-100">
                                  <div className="font-medium text-neutral-600">When</div>
                                  <div className="sm:col-span-2 text-neutral-800">{dateFormat(items.apptDate)} at {convertTimeToAMPM(items.apptTime)} {items.apptTimeZone}</div>
                                </div>
                                <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-3 border-b border-neutral-100">
                                  <div className="font-medium text-neutral-600">Where</div>
                                  <div className="sm:col-span-2 text-neutral-800">{items.apptCity}, {items.apptState} {items.apptZip}</div>
                                </div>
                                <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-3 border-b border-neutral-100">
                                  <div className="font-medium text-neutral-600">Lender</div>
                                  <div className="sm:col-span-2 text-neutral-800">{items.apptLender}</div>
                                </div>
                                <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-3 border-b border-neutral-100">
                                  <div className="font-medium text-neutral-600">Scan Backs</div>
                                  <div className="sm:col-span-2">
                                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${items.scanBack === 'true' ? 'bg-amber-100 text-amber-800' : 'bg-neutral-100 text-neutral-800'}`}>
                                      {scanBackCheck(items.scanBack)}
                                    </span>
                                  </div>
                                </div>
                                <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-3 border-b border-neutral-100">
                                  <div className="font-medium text-neutral-600">Transaction Type</div>
                                  <div className="sm:col-span-2 text-neutral-800">{setTransactionType(items.transactionType)}</div>
                                </div>
                                <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-3 border-b border-neutral-100">
                                  <div className="font-medium text-neutral-600">Finance Type</div>
                                  <div className="sm:col-span-2 text-neutral-800">{setFinanceType(items.financeType)}</div>
                                </div>
                                <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-3 border-b border-neutral-100">
                                  <div className="font-medium text-neutral-600">Extra Notes</div>
                                  <div className="sm:col-span-2 text-neutral-800">{items.apptMessages}</div>
                                </div>
                                <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-3">
                                  <div className="font-medium text-neutral-600">Status</div>
                                  <div className="sm:col-span-2">
                                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                                      {items.apptNotaryApproval}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>))}
                      </div>
                    </div>)
                  : <div>{isInitialLoading
                    ? (<div className="flex justify-center items-center py-12">
                        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600"></div>
                      </div>)
                    : (<div className="max-w-2xl mx-auto px-4 mt-6 mb-6">
                        <div className="bg-white rounded-xl shadow-md border border-neutral-200 overflow-hidden">
                          <div className="px-6 py-4 bg-gradient-to-r from-neutral-600 to-neutral-700">
                            <h2 className="text-lg font-semibold text-white">This order has already been assigned</h2>
                          </div>
                          <div className="p-6">
                            <p className="text-neutral-600 mb-4">Thank you for your interest, however this order has already been assigned. Please be on the lookout for future orders!</p>
                            <p className="font-medium text-neutral-800">Pinpoint Field Services Team</p>
                          </div>
                        </div>
                      </div>)}
                  </div>}
              </div>
            }
          </div>}
          {showClaimForm &&
            (<div className="max-w-2xl mx-auto px-4 mt-6 mb-6">
              <div className="bg-white rounded-xl shadow-md border border-neutral-200 overflow-hidden">
                <div className="px-6 py-4 bg-gradient-to-r from-green-600 to-green-700">
                  <h2 className="text-lg font-semibold text-white">Response</h2>
                </div>
                <div className="p-6">
                  <p className="text-neutral-800">{updateResponse}</p>
                </div>
              </div>
            </div>)
          }
          {showCounterForm &&
            <div className="max-w-2xl mx-auto px-4 mt-6 mb-6">
              <div className="bg-white rounded-xl shadow-md border border-neutral-200 overflow-hidden">
                <div className="px-6 py-4 bg-gradient-to-r from-blue-600 to-blue-700 flex items-center justify-between">
                  <h2 className="text-lg font-semibold text-white">Counter Offer</h2>
                  <button
                    type="button"
                    className="text-white/80 hover:text-white text-2xl font-light leading-none"
                    onClick={() => { setShowCounterForm(false); setShowAppt(true); }}
                    aria-label="Close"
                  >
                    &times;
                  </button>
                </div>
                <div className="p-6">
                  <form onSubmit={onSubmitHandler}>
                    <div className="mb-4">
                      <label htmlFor="counterOffer" className='block text-sm font-medium text-neutral-700 mb-2'>
                        Enter an offer in a whole dollar amount (Current Offer = <span className="font-semibold text-green-600">${initialBid}</span>):
                      </label>
                      <input
                        className='w-full px-4 py-3 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-lg'
                        id="counterOffer"
                        onChange={(e)=>onChangeEvent(e)}
                        pattern="^\$?\d+(\.\d{1,2})?$"
                        type="tel"
                        value={setFee()}
                        required
                      />
                    </div>
                    <input
                      className='w-full sm:w-auto bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-8 rounded-lg transition-colors cursor-pointer'
                      type="submit"
                      value="Submit Counter Offer"
                    />
                  </form>
                </div>
              </div>
            </div>
          }
          {isLoading &&
            (<div className="flex justify-center items-center py-12">
              <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600"></div>
            </div>)}
        </Fragment>
    )
   };

export default Preview;